<template lang="pug">
  v-content(class="fundo")
    v-container(fluid class="bloco_imagem_topo")
      v-layout(row wrap)
        v-flex(xs12)           
          v-img(:src="require('../assets/sala2.jpg')" class="imagens_topo" max-height="380")
            span(class="labelpic") </br>&nbsp&nbsp&nbsp&nbsp ÁREAS DE ATIVIDADE
      v-layout(row wrap class="scrollfundo") 
        v-flex(xs1)
        v-flex(xs4)
          v-card(flat)
            v-card-text(class="texto_titulo") </br>&nbsp&nbsp&nbsp&nbsp ÁREAS DE ATIVIDADE
            span(class="separator")
            v-list
              v-list-tile(v-for="item in areas" :key="item.id" :href="item.href" :target="item.target")
                v-list-tile-content 
                  v-btn(flat class="menu_actividades" @click.native="onChangeArea(item.id)") {{ item.title }}
        v-flex(xs6)
          v-card(flat)
            br
            br
            br
            v-card-text(class="texto_titulo" v-html="currentTitle")
            p
            v-card-text(class="texto1" v-html="currentText")                
        v-flex(xs1)

    v-footer(class="footer400")
      v-flex(xs12)
        v-layout(justify-center row wrap)
          v-layout(justify-center row wrap)
            v-btn(flat v-for="item in menu" :key="item.id" v-on:click="$emit('onChangeComponent',item.comp)" class="footerlinks") {{ item.title }}
        v-layout(justify-center row wrap)
        v-layout(justify-center row wrap)
          v-flex(xs1)
          v-flex(xs3)
            v-layout(justify-center row wrap)        
              p
              br
              p(class="texto_fundo2") </br></br></br>© 2019 Luis S. Rodrigues & Associados. All Rights Reserved.      
          v-flex(xs8)        

</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
<script>
export default {
  name: "areas_actividade",
  props: ["Area"],
  data: () => ({
    currentArea: 1,
    currentTitle: "",
    currentText: "",
    menu: [    
      { id: '1', title: 'Apresentação', comp: 'apresentacao'},
      { id: '2', title: 'Áreas de Actividade', comp: 'areas_actividade'},
      { id: '3', title: 'Advogados', comp: 'advogados'},
      { id: '4', title: 'Contactos', comp: 'contactos'}         
    ],
    areas: [
      {
        id: "1",
        title: "Direito Comercial",
        text:
          "Prestamos assessoria permanente a empresas nacionais e multinacionais dos setores comercial," +
          "industrial e serviços, desde a sua constituição e ao longo de toda a vida societária, passando pelo acompanhamento contínuo dos órgãos societários," +
          " oferecendo soluções para problemas de governabilidade de sociedades ou ajudando Clientes a zelar por boas práticas de compliance," +
          " ao mesmo tempo que acudimos pontualmente a todas as necessidades de registo de atos societários."
      },
      {
        id: "2",
        title: "Direito Fiscal",
        text:
          "Oferecemos assessoria especializada em matéria de reversão fiscal, ou em sede de inspeções tributárias," +
          " fazendo valer direitos de contribuintes singulares ou coletivos perante a Autoridade Tributária. " +
          "Prestamos assessoria a profissionais não residentes qualificados em atividades de elevado valor acrescentado ou da propriedade intelectual," +
          " industrial ou know-how e a beneficiários de pensões obtidas no estrangeiro que se encontrem atraídos por Portugal, tendo em vista o seu enquadramento " +
          "no regime fiscal para residentes não habituais (RNH) e a obtenção das vantagens fiscais decorrentes desse regime."
      },
      {
        id: "3",
        title: "Contencioso e Arbitragem",
        text:
          "Quando a nossa missão é a de solucionar litígios que requeiram uma intervenção perante os Tribunais," +
          " não o fazemos sem esgotar previamente as soluções negociadas perante o conflito. No âmbito judicial," +
          " os nossos Clientes contam com uma equipa de profissionais motivada e empenhada."
      },
      {
        id: "4",
        title: "Direito Laboral",
        text:
          "Prestamos apoio legal permanente no âmbito laboral, tanto a trabalhadores como" +
          " a empregadores nacionais e multinacionais. Encarregamo-nos não só da contratação de novos trabalhadores de acordo com as" +
          " específicas indicações do Cliente, como da instrução de processos disciplinares, da sua tramitação integral, da negociação de resoluções" +
          " de contratos de trabalho, de processos de extinção de postos de trabalho, despedimentos coletivos, despedimentos sem justa causa, ou mero " +
          "aconselhamento de trabalhadores durante a execução dos respetivos contratos."
      },
      {
        id: "5",
        title: "Direito Penal e das Contraordenações",
        text:
          "Assumimos o patrocínio em processos-crime de pequena ou especial complexidade, " +
          "oferecendo ao Cliente uma equipa empenhada e motivada com grande capacidade de trabalho."
      },
      {
        id: "6",
        title: "Direito Comunitário e da Concorrência",
        text:
          "Prestamos assessoria contínua a Clientes com atividades em setores regulados," +
          " atualizando-nos permanentemente quanto às regras do mercado interno e oferecendo aconselhamento seguro sobre as variadas questões que nos são suscitadas."
      },
      {
        id: "7",
        title: "Direito dos Estrangeiros",
        text:
          "Seja no quadro dos regime preferente de ARI – Autorização de Residência para Atividades de Investimento (Golden Visa)" +
          ", seja no quadro da atribuição e aquisição de nacionalidade portuguesa, ou da legalização de estrangeiros através dos expedientes " +
          "tradicionais, ou da contratação de estrangeiros em Portugal, contamos com uma experiência de mais de 40 anos a solucionar casos de " +
          "forma urgente e expedita. Prestamos também um apoio a Clientes estrangeiros para quem promovemos revisão de sentenças estrangeiras em Portugal " +
          "ou a revisão de sentenças portuguesas no estrangeiro."
      },
      {
        id: "8",
        title: "Imobiliário",
        text:
          "Através de due diligence legal, apoiamos os nossos Clientes na tomada de decisões sobre " +
          "investimento imobiliário e transmissão de ativos, proporcionando-lhes um adequado enquadramento legal da operação projetada e " +
          "assegurando-lhes o cumprimento de todos os requisitos legais, incluindo nos casos em que o investimento é realizado ao abrigo do regime da " +
          "ARI – Autorização de Residência para Atividades de Investimento (Golden Visa). A nossa atuação abrange a negociação dos aspetos da operação e a " +
          "redação do contrato adequado em cada situação, desde a promessa de compra e venda, permuta, empreitada no setor da construção civil, cessão de exploração " +
          "de estabelecimento comercial, trespasse e outros, bem como a obtenção da documentação necessária para o efeito, como licenças e certificados de desempenho " +
          "energético, e o acompanhamento do Cliente até à conclusão da operação." +
          "</br></br>" +
          "No âmbito do arrendamento contamos com uma equipa de profissionais experientes que proporciona um aconselhamento adequado ao Cliente no " +
          "cumprimento das suas obrigações e na gestão adequada dos seus ativos imobiliários, acompanhando-o em todas as fases do procedimento de transição dos " +
          "contratos para o novo regime do arrendamento urbano e de atualização da renda e, em caso de litígio, de despejo com vista à entrega coerciva do imóvel locado." +
          "</br></br>" +
          "Também prestamos assessoria a proprietários e condomínios, desde a constituição da propriedade horizontal e do condomínio, sua gestão, preparação e assistência" +
          " a assembleias de condóminos e cobrança das quotas em dívida, até ao patrocínio de ações judiciais ou nos julgados de paz."
      },
      {
        id: "9",
        title: "Direito do Consumo e das Novas Tecnologias",
        text:
          "Prestamos apoio no âmbito da defesa do consumidor; a nossa equipa continuamente se atualiza " +
          "em relação a contratos celebrados à distância (comércio eletrónico, e-commerce), revertendo, a favor dos n/ Clientes, as situações abusivas que " +
          "nos são suscitadas; zelamos pela proteção de dados pessoais tanto na ótica do respetivo titular como na ótica do responsável pelo respetivo tratamento. " +
          "Contamos com uma equipa jovem e dinâmica na análise de novos problemas criados pela constante evolução tecnológica."
      },
      {
        id: "10",
        title: "Investimento Estrangeiro",
        text:
          "Apoiamos as empresas nos seus projetos de investimento no estrangeiro através das nossas sucursais em Espanha" +
          " e América latina, no âmbito técnico-jurídico, fiscal ou administrativo." +
          "</br></br>" +
          "Nos casos em que o investimento é realizado ao abrigo do regime da ARI – Autorização de Residência para Atividades de Investimento (Golden Visa)," +
          " mediante due diligence legal apoiamos os nossos Clientes na tomada de decisões, proporcionando-lhes um adequado enquadramento legal da operação projetada " +
          "e assegurando-lhes o cumprimento de todos os requisitos legais." +
          "</br></br>" +
          "Em articulação com a equipa de direito fiscal, prestamos assessoria a profissionais não residentes qualificados em atividades de elevado valor acrescentado" +
          " e a beneficiários de pensões obtidas no estrangeiro que pretendam investir no nosso país, tendo em vista o seu enquadramento no regime fiscal para residentes " +
          "não habituais (RNH) e a obtenção das vantagens fiscais decorrentes desse regime." +
          ""
      },
      {
        id: "11",
        title: "Contratos",
        text:
          "Estudamos, elaboramos e redigimos todo o tipo de contratos públicos, privados, nacionais e internacionais, " +
          "dos mais tradicionais aos mais complexos e sofisticados, fazendo uso de uma atualização contínua para responder às evoluções do mercado."
      },
      {
        id: "12",
        title: "Direito da Familia e Menores",
        text:
          "Cuidamos das questões relacionadas com a vida dos nossos Clientes com o máximo rigor, sigilo e ética profissionais," +
          " entre elas divórcios, partilhas e regulação de responsabilidades parentais, contribuindo para a justa definição de regimes de guarda de menores e de pensões de alimentos," +
          " ou suscitando a sua revisão."
      },
      {
        id: "13",
        title: "Direito Civil Privado",
        text:
          "Assessoramos os nossos Clientes no marco do cumprimento das obrigações contratuais, defendemos interesses e fazendo" +
          " valer direitos judicial ou extrajudicialmente. Em caso de litigio, proporcionamos patrocínio preventivo adequado que permita recurso aos Tribunais em posição mais robusta e segura."
      },
      {
        id: "14",
        title: "Propriedade Intelectual e Industrial",
        text:
          "Em sede de propriedade intelectual ou industrial, registamos para os nossos Clientes as marcas, patentes e design," +
          " além de fazermos fazer direitos lesados nesse âmbito, em estreita conexão com o departamento de penal e contraordenacional; prestamos toda a assessoria judicial e extrajudicial" +
          " em disputas de marcas, e aconselhamos preventivamente os nossos Clientes no uso das mesmas."
      },
      {
        id: "15",
        title: "Bancário e Seguros",
        text:
          "Apoiamos vários grupos seguradores na sua atividade de implementação, e na criação de estrutura organizacional," +
          " jurídica e administrativa. Damos assessoria em todo o processo de adaptação legal, desde a conformação de regras compliance à elaboração, revisão e adaptação de clausulados."
      },
      {
        id: "16",
        title: "Direito Falimentar e da Recuperação de Empresas",
        text:
          "Dispomos de uma equipa empenhada na restruturação e recuperação empresarial de unidades " +
          "economicamente viáveis, contando com colaboração de profissionais da área económica e de gestão. Aconselhamos e patrocinamos os nossos Clientes quando se torna necessário " +
          "recorrer aos mecanismos legais disponíveis com vista à sua revitalização pessoal ou da sua empresa, quer extrajudicialmente através do SIREVE, quer judicialmente através do " +
          "processo especial de revitalização (PER) ou da declaração de insolvência. A defesa dos interesses dos credores nestes processos, com a reclamação atempada dos seus créditos, a " +
          "representação em negociações, em assembleias e em comissões de credores, assim como o acompanhamento de toda a tramitação processual junto dos administradores judiciais ou da insolvência," +
          " tem sido também uma área privilegiada da nossa atuação."
      }
    ]
  }),

  methods: {
    onChangeArea(area) {
      this.currentArea = area;
      this.currentTitle = this.areas[this.currentArea - 1].title;
      this.currentText = this.areas[this.currentArea - 1].text;
    }
  },

  mounted: function() {
    this.$nextTick(function() {
      // // Code that will run only after the
      // // entire view has been rendered
      this.currentArea = this.Area;
      this.currentTitle = this.areas[this.currentArea - 1].title;
      this.currentText = this.areas[this.currentArea - 1].text;
      window.scrollTo(0, 0);
    });
  }
};
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
<style>
</style>
